<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" width="460px" @open="focus" @closed="$emit('closed')">
    <input-session ref="inputSess" :title="title" :sess="sess" :focusID="focusID" :sessDir="sessDir" validateFileExist="false" @updateSession="updateSession" @ok="okHandler" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="mini">取 消</el-button>
      <el-button v-show="posting" type="primary" size="mini"><i class="el-icon-loading" /></el-button>
      <el-button v-show="! posting" type="primary" @click="okHandler" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import InputSession from './inputSession'
import model from "../../model"
import path from 'path'

export default {
  name: "editSession",
  components: {InputSession},
  data() {
    return {
      visible: false,
      title: "会话属性",
      posting: false,
      focusID: 'sess-edit-input-name',

      // from show callback args
      sessDir: "/",
      sess: new model.Session(),
      oldSess: new model.Session(),
    }
  },
  computed: {
    sessFilePath: function() {
      return path.join(this.sessDir, this.sess.Name)
    },
  },
  mounted() {
    // let self = this

    // // 注册显示会话面板回调
    // this.env.ui.showEditSessionAddCallback((sessAndPath) => {
    //   self.sessDir = sessAndPath.path ? sessAndPath.path : "/"
    //   if (!sessAndPath.sess) {
    //     self.sess = new model.Session()
    //     return
    //   }

    //   self.updateSession(sessAndPath.sess)
    //   for (let key in self.oldSess) self.oldSess[key] = sessAndPath.sess[key]
    //   self.visible = true

    //   let opts = {
    //     'encryptedPassword': sessAndPath.sess.Password // String | 加密后的字符串
    //   };
    //   self.api.sess.getSessionPasswordDecrypted(opts, (error, data, response) => {
    //     if (error) {
    //       self.api.errHandler(self, error, response)
    //     } else {
    //       self.sess.Password = data
    //       self.updateInputSessVal()
    //     }
    //   })
    // })
  },
  watch: {
    visible: function() {
      if (this.visible) {
        this.updateInputSessVal()
      }
    },
  },
  methods: {
    show(sessFullPath) {
      let self = this
      console.debug("editSession: show: sessFullPath: ", sessFullPath)
      self.api.hifs.getFile(sessFullPath, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
        } else {
          console.debug('API called successfully. Returned data: ' + data);
          let sess = JSON.parse(data)
          console.debug("editSession: show: sess:", sess)

          // 修复以往可能出现的错误数据: 文件内容记录的 Name 字段和文件名不一致的问题
          let basename = path.basename(sessFullPath)
          console.debug("editSession: show: basename:", basename)
          console.debug("editSession: show: sess.Name:", sess.Name)
          if (sess.Name !== basename) {
            console.debug("editSession: show: reset sess.Name to filename")
            sess.Name = basename
          }

          self.sessDir = path.dirname(sessFullPath)
          for (let key in self.oldSess) self.oldSess[key] = sess[key]
          self.title = path.join(self.sessDir, sess.Name)
          self.updateSession(sess)
          self.visible = true

          let opts = {
            'encryptedPassword': sess.Password // String | 加密后的字符串
          }
          self.api.sess.getSessionPasswordDecrypted(opts, (error, data, response) => {
            if (error) {
              self.api.errHandler(self, error, response)
            } else {
              self.sess.Password = data
              self.updateInputSessVal()
            }
          })
        }
      })      
    },
    hide() {this.visible = false},
    focus() {this.utils.domFocusById(this.focusID)},
    updateInputSessVal() {
      this.$refs.inputSess ? this.$refs.inputSess.updateInputVal(this.sess) : null
    },
    // openSessionHandler: function() {
    //
    // },
    // closedSessionHandler: function() {
    //   this.env.termFocusCurrent()
    // },
    updateSession(s) {
      for (let key in this.sess) this.sess[key] = s[key]
    },
    okHandler() {
      // 检查输入内容是否有效
      if (! this.$refs.inputSess.isInputValid()) {
        this.$message.error("会话参数错误")
        return
      }

      if (this.oldSess.Name === this.sess.Name) {
        this.postSession()
        return
      }
      this.renameSession()
    },
    sessExistHandler() {
      this.$message.error("会话已存在")
    },
    successHandler() {
      this.visible = false
      this.env.showSessionList({refresh: true})
    },
    renameSession() {
      let self = this

      // 检查重命名后的会话文件是否已存在
      this.api.hifs.getPath(self.sessFilePath, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
        } else {
          // 同名会话文件已存在
          if (data == true) {
            self.$refs.inputSess.inputNameValidateResult = `会话 "${self.inputName}" 已存在`
            return
          }

          // 会话文件不存在, 先删除旧文件, 再直接提交新文件
          self.api.hifs.deleteFile(`${self.sessDir}/${self.oldSess.Name}`, (error, data, response) => {
            self.sessPosting = false
            if (error) {
              self.api.errHandler(self, error, response)
            } else {
              console.log("renameSession: deleteFile: data", data)
              console.log("renameSession: deleteFile success, post new file")
              self.postSession()
            }
          })
        }
      })
    },
    postSession() {
      this.api.postSession(this, this.sess, this.sessFilePath, this.successHandler)
    },

  },
}
</script>

<style scoped>
.filepath-ctn {
  padding: 0 6px;
}
</style>
